<template>
    <div class="booking-component text-none pa-4 pa-md-2">
        <div class="main-header text-left mb-6 mt-6">
          Lista uprawnień
        </div>

        <div>  
          <div class="search-bar text-left pa-md-6 pa-0 mt-4 d-flex flex-md-row flex-column align-start align-md-center">
            <div class="search-bar-element mr-4 d-flex flex-column align-start flex-grow-1">
              <div class="search-bar-label mb-2 mt-md-0 mt-4">
                Imię, nazwisko lub PESEL pacjenta
              </div>
              <input class="search-bar-input query" v-model="search_data.query" @change="setNewFilters"/>
            </div>
            <div class="search-bar-element mr-4 d-flex flex-column align-start">
              <div class="search-bar-label mb-2">
                &nbsp;
              </div>
              
              <v-btn
                  flat
                  rounded
                  color="primary"
                  height="40"
                  class="text-uppercase"
                  @click="setNewFilters"
                  :prepend-icon="'mdi-magnify'"
              >
                  Szukaj
              </v-btn>
            </div>
          </div>
          <div class="search-bar text-left">
            <v-btn id="reset" flat variant="plain" color="primary"
              :class="['ml-md-2 ml-0 mb-4 px-md-4 mt-md-0 mt-6']" 
              :size="$vuetify.display.mobile ? 'x-small' : 'x-default'" @click="resetAll">
              Wyczyść
            </v-btn>
          </div>
        </div>
        <div class="info-wrapper">
          <div v-if="!isLoading && !grants.length" :class="['info d-flex flex-column justify-center mt-4 mb-2 mx-4 py-12 px-9', $vuetify.display.mobile ? 'mobile' : 'text-left']">
            <div class="header mb-6 mb-md-4">
              {{this.hasFilters ? "Nie znaleziono rezerwacji" : "Nie ma jeszcze żadnych rezerwacji"}}
            </div>
            <div class="subheader">
              {{this.hasFilters ? "Zmień kryteria wyszukiwania" : "Po dodaniu ich, będą one widoczne w tym miejscu"}}
            </div>
          </div>
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
            :size="50"
            :width="5"
          ></v-progress-circular>
        </div>

        <div v-if="grants.length" :key="refresh_key">
          <div v-for="(grant, index) in grants" :key="index" class="mt-4">
            <!-- <coordinator-reservation-component :reservation="reservation" @compare-dialog="hasOpenCompareDialog"/> -->
             <GrantComponent :grant="grant" :grant-index="(page-1) * pageSize + index + 1"/>
             <!-- <hr /> -->
          </div>
          <v-row class="my-9" v-if="paginationLength">
            <v-col cols="12" md="9">
              <v-pagination
                v-model="page"
                color="primary"
                :length="paginationLength"
              ></v-pagination>
            </v-col>
            <v-col cols="6" md="2" class="px-0 text-right">
                <div class="results-page-size-label mt-3 pr-2">{{$t('results.per_page_label')}}:</div>
            </v-col>
            <v-col cols="4" md="1" class="pl-0 pr-3">
                <div class="float-left mt-1 mb-16 w-100">
                    <CustomSelect
                        v-model="selectedPageSize"
                        :multiple="false"
                        :flat="true"
                        size="small"
                        :chip="false"
                        :options="[{key: 5}, {key: 10}, {key: 20}, {key: 50}]"/>
                </div>
            </v-col>
          </v-row>
        </div>
    </div>
</template>

<script>
import CustomSelect from "../CustomSelectComponent";
import GrantComponent from "./GrantComponent.vue";
import { RemoteFilters } from 'design-system-ui-components'
import axios from "axios";

export default {
    name: "booking-component",
    data: () => {
        return {
            grants: [],
            selectedPageSize: [],
            page: 1,
            pageSize: 10,
            paginationLength: 0,
            isLoading: false,
            prices: null,
            refresher: null,
            refresh_key: 0,
            openedCompareDialog: false,
            search_data: {
              query: "",
              selected_location: "",
              selected_status: "",
              selected_date: "",
            },
            search_data_local: {
              query: "",
              selected_location: "",
              selected_status: "",
              selected_date: "",
            },
            location_open: false,
            status_open: false,
            hasFilters: false,
            locations: [],
            statuses: [
              {
                code: "CANCELED",
                id: 1
              },
              {
                code: "CANCELED_BY_USER",
                id: 6
              },
              {
                code: "CREATED",
                id: 3
              },
              {
                code: "ERROR",
                id: 4
              },
              {
                code: "FINISHED",
                id: 5
              },
              {
                code: "PROCESSED",
                id: 2
              },
              {
                code: "PAYMENT_IN_PROGRESS",
                id: 7
              },
            ]
        }
    },
    components: {
      CustomSelect,
      GrantComponent
    },
    setup() {
       
    },
    created() {
      this.selectedPageSize = [{key: this.pageSize}]
    },
    mounted() {
      this.getDicts().then(() => {
        this.refresher = setInterval(() => {
          if (!this.openedCompareDialog) {
            this.init(this.page);
            this.refresh_key++;
          }
        }, 60 * 1000);  
      })
    },
    unmounted() {
      clearInterval(this.refresher);
    },
    watch: {
      page(p) {
        this.init(p);
        window.scrollTo({top: 0, behavior: 'smooth'});
      },
      selectedPageSize(p) {
        this.pageSize = p[0].key
        if (this.page != 1) {
          this.page = 1
        } else {
          this.init(1)
        }
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
    },
    methods: {
      hasOpenCompareDialog(d) {
        this.openedCompareDialog = d
      },
      init(page = 1) {
        this.isLoading = true
        this.page = page
        axios.get(this.getUrl(page))
        .then((response) => {
          this.grants = response.data.grants;
          this.paginationLength = Math.ceil(response.data.total_count / this.pageSize);
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        })
      },
      resetAll() {
        this.search_data = {
              query: "",
              selected_location: "",
              selected_status: "",
              selected_date: ""
            },
        this.hasFilters = false;
        this.setNewFilters();
      },
      getDicts() {
        return new Promise((resolve, reject) => {
          axios.get('/api/personal_data/dictionary')
            .then((response) => {
              this.locations = response.data.location;
              resolve(response);
            })
            .catch(error => {
              console.error(error);
              reject(error)
            })
          })
      },
      getUrl(page) {
        this.hasFilters = false;
        const api = "api/coordinator/grants";

        const filters = new RemoteFilters();

        if(this.search_data_local.query) {
          filters.add({
            property: "query",
            operator: "_like",
            value: this.search_data_local.query,
          })
          this.hasFilters = true;
        }
      
        const pagination = `?pageNumber=${page-1}&pageSize=${this.pageSize}`;

        const url = `${api}${pagination}${this.hasFilters ? '&' + filters.stringify() : ''}`;

        return url;
      },
      setNewFilters() {
        this.search_data_local = {...this.search_data};
        this.init(1)
      }
    }
}
</script>

<style lang="scss" scoped>
.booking-component {
  box-sizing: border-box;
  background: none;
}
.main-header {
  @include nsb-poppins-semibold;
}
.results-page-size-label {
  @include nsb-font-container;
  font-size: 14px;
}
.v-row {
  margin: 0px !important;
  padding: 0px !important;
}

:deep(.v-pagination__item) {
  margin-right: 0px;
  .v-btn {
    @include nsb-font-button-regular;
    font-size: 14px !important;
    line-height: 21px !important;
    max-height: 40px;
    max-width: 40px;
  }
  &.v-pagination__item--is-active {
    .v-btn {
      background-color: $ds-primary !important;
      color: $ds-white !important;
      .v-btn__overlay {
        opacity: 0;
      }
    }
  }
}
:deep(.v-pagination__prev) {
  margin-right: 8px;
  .v-btn {
    font-size: 14px !important;
    max-height: 40px;
    max-width: 40px;
  }
}
:deep(.v-pagination__next) {
  margin-left: 12px;
  .v-btn {
    font-size: 14px !important;
    max-height: 40px;
    max-width: 40px;
  }
}

.info-wrapper {
  position: relative;
  .v-progress-circular {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 999;
    transform: translate(-50%,-50%);
  }
  .info{
    height: 350px;
    .header {
      @include nsb-font-header-bold;
      font-size: 20px !important;
      line-height: 30px !important;
    }
    .subheader {
      @include nsb-font-header;
      font-size: 14px !important;
      line-height: 22px !important;
    }
    &.mobile {
      .header {
        font-size: 14px !important;
        line-height: 22px !important;
      }
      .subheader {
        font-size: 12px !important;
        line-height: 18px !important;
      }
    }
  }
}

.search-bar {
  background: white;
  max-width: 100%;
}
.search-bar-element {
	.search-bar-label {
		@include nsb-font-container;
		font-size: 14px;
		line-height: 21px;
	}
  .query {
    width: 100% !important;
  }
	.search-bar-input, .search-bar-select {
		@include nsb-font-input;
		font-size: 16px !important;
    border-radius: 4px;
    border: 1px solid $ds-background-1 ;
		height: 40px;
		padding: 0px 16px;
    padding-right: 32px;
		outline: none;
    text-overflow: ellipsis;
    option {
      text-overflow: ellipsis;
      padding-right: 32px;
    }
	}
  .search-bar-select-wrapper {
    position: relative;
    .select-icon {
      position: absolute;
      color: $ds-primary;
      top: 8px;
      right: 8px;
      pointer-events: none;
    }
  }
}
</style>